/**
 * lib/gamificationApi.js — thin axios wrapper for Sprint LMS-Gamify.
 */
import api, { formatApiError } from "./api";

export async function getGamificationSummary() {
  return (await api.get("/lms/gamification/summary")).data;
}
export async function getBadgeCatalogue() {
  return (await api.get("/lms/gamification/badges")).data;
}
export async function getPodiumRules() {
  return (await api.get("/lms/gamification/podium-rules")).data;
}
export async function getLeaderboard(limit = 25) {
  return (await api.get(`/lms/gamification/leaderboard?limit=${limit}`)).data;
}
export async function adminListRules() {
  return (await api.get("/admin/lms/gamification/rules")).data;
}
export async function adminUpdateRule(body) {
  return (await api.post("/admin/lms/gamification/rules/update", body)).data;
}
export { formatApiError };
